// extracted by mini-css-extract-plugin
export default {"task-list__ul":"TaskList_task-list__ul__lDClk"};